import { ComponentNameEnum, BaseButtonFieldConfig } from '@/types';

const defaultValue = 'stacked';
const property = 'spm_options_layout_';

const optionsLayoutFieldConfig: BaseButtonFieldConfig = {
  componentName: ComponentNameEnum.BUTTON_GROUP,
  options: {
    [defaultValue]: {
      title: 'templateBuilder.fields.optionsStacked',
      iconClass: 'fa-arrows-v',
      property,
      defaultValue,
    },
    inline: {
      title: 'templateBuilder.fields.optionsInline',
      iconClass: 'fa-arrows-h',
      property,
      defaultValue,
    },
  },
};

export default optionsLayoutFieldConfig;
